'use strict';

import DataTransport from "@/helpers/data-transport";
import AlertMessage from "@/helpers/alert-message";

(function() {
    const transport = new DataTransport();
    const alertMessage = new AlertMessage();
    const launchButtons = document.querySelectorAll('[data-role="launch-server"]');
    const locationSelects = document.querySelectorAll('[data-role="location-select"]');

    // Sync all location selects when any of them changes
    locationSelects.forEach(select => {
        select.addEventListener('change', (event) => {
            console.log("Changed");
            const selectedValue = event.target.value;
            locationSelects.forEach(s => {
                s.value = selectedValue;
            });
        });
    });

    // Use the last location select for launching
    const lastLocationSelect = locationSelects[locationSelects.length - 1];

    launchButtons.forEach(btn => {
        btn.addEventListener("click", async function(event) {
            event.preventDefault();

            alertMessage.HideAlert();

            btn.disabled = true;
            const originalText = btn.innerText;
            btn.innerText = "Please wait...";

            const gameId = btn.getAttribute('data-gameId');
            const days = btn.getAttribute('data-days');
            const players = btn.getAttribute('data-players');
            const location = lastLocationSelect.value;

            const formData = new FormData();
            formData.append('days', days);
            formData.append('players', players);
            formData.append('location', location);

            await transport.PostFormData(`/checkout/?exec=createOrder&gameId=${encodeURIComponent(gameId)}`, formData)
                .then(async data => {
                    console.log(data);
                    if (typeof data === 'object') {
                        if (data.error) {
                            alertMessage.ShowError(data.message);
                        } else {
                            // success
                            //
                            if (data.data.url) {
                                window.location = data.data.url;
                            } else {

                            }
                        }
                    } else {
                        // Raw Text;
                    }
                })
                .catch(error => console.error('Failed to fetch data:', error))
                .finally(() => {
                    // Restore button only if not redirecting
                    btn.disabled = false;
                    btn.innerText = originalText;
                });
        });
    });
})();
